"use client";

import { useThrottledCallback, useVisibilityChange } from "@opensea/ui-kit/hooks";
import { useEffect } from "react";
import { SYNC_AUTH_LOCAL_STORAGE_KEY } from "../../polychain/hooks/useSyncAuth";
import { AccountActions } from "../accountStore";
const SYNC_AUTH_STATUS_THROTTLE_TIME = 1000;
export function useSyncAuthStatus({
  siweAdapter,
  trackError
}) {
  const isPageVisible = useVisibilityChange();
  const syncAuth = useThrottledCallback(async () => {
    if (!siweAdapter) {
      return;
    }
    try {
      const session = await siweAdapter?.getSession();
      AccountActions.setAuthenticated(Boolean(session));
    } catch (error) {
      trackError?.(error, {
        tags: {
          source: "useSyncAuthStatus"
        }
      });
    }
  }, SYNC_AUTH_STATUS_THROTTLE_TIME);
  useEffect(function syncAuthWhenPageBecomesVisible() {
    if (isPageVisible) {
      syncAuth();
    }
  }, [isPageVisible, syncAuth]);
  useEffect(
  // Handles syncing auth when changes happen in another tab
  function syncAuthOnLocalStorageMessage() {
    const eventHandler = e => {
      // Any changes to the sync auth key will trigger a sync
      if (e.key === SYNC_AUTH_LOCAL_STORAGE_KEY) {
        syncAuth();
      }
    };
    window.addEventListener("storage", eventHandler);
    return () => {
      window.removeEventListener("storage", eventHandler);
    };
  }, [syncAuth]);
}